import src from "IMAGE";
export default { src, width: 3300, height: 6701, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAIAAABRUclSAAAAOElEQVR42lWLSQ4AMAgC/f97XTkVNWlTLjoZEFWNCABVJfwy84OaiLvzYCJbeGY3be66wczI9IQD6xNdKIUZX/MAAAAASUVORK5CYII="};
